import React, { useState } from "react";
import { default as AdmissionHomePage } from "./AdmissionHomePage";
import AdmissionInquiry from "./AdmissionInquiry";

const SwitchAdmission = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <AdmissionHomePage />
          </div>
        );

      case 2:
        return (
          <div>
            <AdmissionInquiry />
          </div>
        );

      default:
        return (
          <div>
            <AdmissionHomePage />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Home</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Inquiry</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchAdmission;
